export default __webpack_public_path__ + "static/media/flowt.4f9dfd5b.svg";